import { getDeviceId } from "@/lib/deviceId";

// Le PIN hors-ligne est LIÉ à l'appareil ET à l'utilisateur : le PIN d'un compte
// ne peut jamais déverrouiller la session d'un autre compte sur le même appareil.
const PREFIX = "biashara_pin";
const LEGACY_KEY = "biashara_pin"; // ancien format global (appareil uniquement) — à purger
const ITER = 150000;
const enc = new TextEncoder();

function hex(buf) {
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}
function fromHex(s) {
  const a = new Uint8Array(s.length / 2);
  for (let i = 0; i < a.length; i++) a[i] = parseInt(s.substr(i * 2, 2), 16);
  return a;
}

// Portée du PIN : tenant + utilisateur. Sans utilisateur → chaîne vide (aucun PIN utilisable).
export function pinScope(user) {
  return user && user.id ? `${user.tenant_id || "t"}:${user.id}` : "";
}
function storeKey(scope) {
  return scope ? `${PREFIX}.${scope}` : PREFIX;
}

// Supprime tout ancien PIN global non lié à un utilisateur (empêche le déverrouillage inter-comptes).
export function purgeLegacyPin() {
  try { localStorage.removeItem(LEGACY_KEY); } catch (e) {}
}

// Dérivation PBKDF2 salée, liée à l'appareil ET à la portée utilisateur — résiste au brute-force.
async function pbkdf2(pin, saltBytes, iterations, scope) {
  const base = await crypto.subtle.importKey("raw", enc.encode(`${pin}::${getDeviceId()}::${scope}`), "PBKDF2", false, ["deriveBits"]);
  const bits = await crypto.subtle.deriveBits({ name: "PBKDF2", salt: saltBytes, iterations, hash: "SHA-256" }, base, 256);
  return hex(bits);
}

export function hasPin(scope) {
  if (!scope) return false;
  return !!localStorage.getItem(storeKey(scope));
}

export async function setPin(pin, scope) {
  if (!scope) throw new Error("PIN sans utilisateur");
  const salt = crypto.getRandomValues(new Uint8Array(16));
  const h = await pbkdf2(pin, salt, ITER, scope);
  localStorage.setItem(storeKey(scope), `pbkdf2$${ITER}$${hex(salt)}$${h}`);
}

export function clearPin(scope) {
  if (!scope) return;
  localStorage.removeItem(storeKey(scope));
}

export async function verifyPin(pin, scope) {
  if (!scope) return false;
  const stored = localStorage.getItem(storeKey(scope));
  if (!stored || !stored.startsWith("pbkdf2$")) return false;
  const [, iterStr, saltHex, h] = stored.split("$");
  const calc = await pbkdf2(pin, fromHex(saltHex), Number(iterStr) || ITER, scope);
  return calc === h;
}
